import { PATH } from '@app/index';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const HIDE_GAME_ADVANTAGES_KEY = 'hideGameAdvantages';

export const useShowGameMechanics = () => {
  const nav = useNavigate();
  const [show, setShow] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    const hidden = localStorage.getItem(HIDE_GAME_ADVANTAGES_KEY) === 'true';
    if (!hidden) {
      setShow(true);
    }
  }, []);

  const handleStart = () => {
    if (dontShowAgain) {
      localStorage.setItem(HIDE_GAME_ADVANTAGES_KEY, 'true');
    }
    nav(PATH.LOTTERY_ALL_AT_ONCE);
    setShow(false);
  };

  return {
    show,
    handleStart,
    dontShowAgain,
    setDontShowAgain,
  };
};
